import UI from "./base/UI";

import { isA11yCheckVersion } from "../functions/a11y.ui";
import {SavingsStory} from "../functions/simple.ui";
/**
 * Range
 */

/**
#### HTML 구조 및 Data 속성 사용법 (컴포넌트 input 상단영역의  range 위치)
** [http://172.20.160.28:9700/kbank_html_mmk/components/component_input.html](http://172.20.160.28:9700/kbank_html_mmk/components/component_input.html)
*/

class Range extends UI { 
    defaults = {
      rangeLen : 10,
      value : 0,
      thumbText : [1,2,3,4,5,7,10],
      color :'#4262FF', // 240911 파란색으로 변경 
      bgcolor :'#E0E6F1',  // 240911 색상 변경 
      stepColor :'#E0E6F1', // 240911 색상 변경 
      bgcolorBefore :'#e0e0e0',
      rangeStep:true,
    };

    constructor(el, options) {
        super('Range', el);

        this.init(el, options);
    }

    init(el, options) {
        /*! s: FETASK-a11y page Range Input 접근성 v.1.0.0 */
        if(isA11yCheckVersion()){
          // input range 라임색상 -> #4262FF 색으로 변경
          this.defaults = {
            ...this.defaults,
            ...{
              color:'#4262FF', 
              bgcolor:'#E0E6F1',
              stepColor:'#E0E6F1',
            }
          };
        }
        /*! e: FETASK-a11y page Range Input 접근성 v.1.0.0 */

        this.defaults = {...this.defaults, ...this.parseOptions(options)};
        this.render();
    }
    /**
     * 비동기적으로 실행시 update()
     * @example 
     * $('.ui-range').data('ui').update();
     */
    update() {
      const $input = this.$el.find('input');
      let $thumb; // // 월 상환금액
      if (this.defaults.type == "repayment") { // 월 상환금액
        $thumb = this.$el.find('.thumb-index');
        this.defaults.value = Number(this.$el.attr('data-value'))
        $thumb.removeAttr('style');
      } else {
        const v = this.$el.attr('data-value');
        this.defaults.value = isNaN(Number(v)) ? v : Number(v);
      }

      if (this.defaults.pointerTop != undefined) {
        this.defaults.pointerTop = this.$el.attr('data-pointer-top')
      }
      if (this.defaults.pointerBot != undefined) {
        this.defaults.pointerBot = this.$el.attr('data-pointer-bot')
      }
      $input.removeAttr('style');
      this.render()
      //this.setValue();
    }

    
    render() {
        this.detachEvents();
        this.attachEvents();
        console.log('?????')
    }

    /**
   * 데이터가 바뀐 경우 setValue()
   * @example 
   * $('.ui-range').data('ui').setValue();
   */
    setValue() {
        const $input = this.$el.find('input');
        const zeroNum =  $input.attr('data-zeronum');
        (zeroNum) ? $input.attr('min', $input.attr('min')) : $input.attr('min', 1); // 추후 min 값 변경이 필요할시 수정 필요한 부분

        /*! s: FETASK-a11y page Range Input 접근성 v.1.0.0 */
        const isA11yCheck = isA11yCheckVersion();
        /*! e: FETASK-a11y page Range Input 접근성 v.1.0.0 */

        let fill;
        if (this.defaults.type == "repayment") { // 월 상환금액 줄이기
          this.defaults.thumbText = this.defaults.thumbText.filter(years => {
            this.defaults.thumbText.push(years);
            return years >= this.defaults.value;
          })
          var mappingValue =  this.defaults.thumbText.indexOf(this.defaults.value)
          $input.val(mappingValue)
          this.defaults.rangeLen = this.defaults.thumbText.length
          const $thumb = this.$el.find('.thumb-index');
          $input.attr('max', this.defaults.rangeLen)

          // range 색 채우는 곳
          fill = (($input.val() - $input.attr('min')) / ($input.attr('max') - $input.attr('min'))) * 100;
          $input.css('background', `linear-gradient(to right, ${this.defaults.bgcolorBefore} 12px, ${this.defaults.color} 12px, ${this.defaults.color} ${fill}%, ${this.defaults.bgcolor} ${fill}%, ${this.defaults.bgcolor} 100%)`);


          const _value = Number(((mappingValue+1 - $input.attr('min')) * 100) / ($input.attr('max') - $input.attr('min')))
          if (!$thumb.find('.first-txt').length > 0) {
            $thumb.append('<span class="first-txt">움직여서 기간을 늘려주세요</span>')
          }

          $thumb.find('.txt').text(`${this.defaults.thumbText[mappingValue]}년`).addClass('hide-txt')
          if (_value != 0) {
            $thumb.find('.first-txt').hide()
            $thumb.find('.txt').removeClass('hide-txt')
            $thumb.css({
              left: `calc(${_value}% + (${-6 - _value * 0.30}px))`
            })
          } else {
            if ($input.attr('min') == 1) {
              $thumb.find('.first-txt').show()
              $thumb.addClass('pos-left')
            } else {
              $thumb.find('.first-txt').hide()
              $thumb.css({
                left: `calc(${_value}% + (${-6 - _value * 0.30}px))`
              })
            }
          }
          $thumb.attr('idx-num', `${mappingValue}`)
          if (this.defaults.textId != undefined) {
            $(`#${this.defaults.textId}`).text(`${this.defaults.thumbText[mappingValue]}년`)
          }
        } else {
          if (this.defaults.pointerTop != undefined) {
            const $pointerTop = this.$el.find('.pointer-row.top');
            const pointerTopArr = this.defaults.pointerTop.split(' ');
            $pointerTop.find('.item-index').remove();
            if (!$pointerTop.find('.item-index').length > 0 ) {
              for (let i =0; i<pointerTopArr.length; i++) {
                $pointerTop.append(`<div class="item-index"><span class="txt">${pointerTopArr[i]}</span></div>`)
              }
            }
          }
          if (this.defaults.pointerBot != undefined) {
            const $pointerBot = this.$el.find('.pointer-row.bottom');
            const pointerBotArr = this.defaults.pointerBot.split(' ');
            var mappingValue =  pointerBotArr.indexOf(this.defaults.value)
            this.defaults.rangeLen = pointerBotArr.length;
            $input.attr('max', this.defaults.rangeLen);
            $input.attr( "value", mappingValue + 1 );
            $input.val( mappingValue + 1 );
            $pointerBot.find('.item-index').remove();
            
            if (!$pointerBot.find('.item-index').length > 0 ) {
              const botType = this.$el.attr( "data-pointer-bot-type" );
              // CHPFMTASK-2115: (추가) Range 쪽에 텍스트를 누르면 Range가 이동하지 않는것과 텍스트 부분을 접근성 이슈때문에 <button>태그로 수정되어야 하는 이슈
              if( botType === "button" ){
                
                pointerBotArr.forEach((value) => {
                  $pointerBot.append(`<button class="item-index" type="button"><span class="txt">${value}</span></button>`);
                });

                const btn = $pointerBot.find( ".item-index" );
                $( btn[ mappingValue]).focus();
                btn.on( "click", ({ currentTarget }) => {
                  const idx = $( currentTarget ).index();
                  this.$el.attr( "data-value", pointerBotArr[idx]);
                  this.update();

                  this.rangeCallBackAction();
                });

              }else{
                pointerBotArr.forEach((value) => {
                  $pointerBot.append(`<div class="item-index"><span class="txt">${value}</span></div>`);  
                })
              }
            }
          }
        }
        if (this.defaults.rangeStep == true) {
          this.$el.find('.range-value-group').remove();
          if (!this.$el.find('.range-step-wrap').length > 0) {
            $input.wrap('<div class="range-step-wrap"></div>')
          }
          this.$el.find('.range-step-wrap').append('<div class="range-value-group"></div>')
          
          const $rangeBalls = this.$el.find('.range-value-group');
          $rangeBalls.find('.rvalue').remove()
          for (var i = 1; i <= this.defaults.rangeLen; i++) {
            $rangeBalls.append(`<span class="rvalue" num="${i}"></span>`)
          }
          if ($rangeBalls.length > 0) {
            for (var s = 0; s < mappingValue+1; s++) {
              $rangeBalls.find('.rvalue').eq(s).addClass('on')
            }
          }
          $rangeBalls.find('.rvalue').css('background',this.defaults.stepColor)
          $rangeBalls.find('.rvalue.on').css('background',this.defaults.color)
        }
        if (this.$el.closest('.living').length > 0) {
          if ($input.val() == 1) {
            $input.addClass('living-first')
          } else {
            $input.removeClass('living-first')
          }
          if ($input.val() == $input.attr('max')) {
            $input.addClass('living-last')
          } else {
            $input.removeClass('living-last')
          }
        }
        if ($input.closest('.living').length>0 &&this.defaults.rangeLen == 4 ) { // 오늘의 예상 주유 금액 4개일때만
          $input.attr('valuenum', `n${$input.val()}`);
        }
        // range 색 채우는곳
        fill = (($input.attr('value') - $input.attr('min')) / ($input.attr('max') - $input.attr('min'))) * 100;
        $input.css('background', `linear-gradient(to right, ${this.defaults.color} 0%, ${this.defaults.color} ${fill}%, ${this.defaults.bgcolor} ${fill}%, ${this.defaults.bgcolor} 100%)`);

        /*! s: FETASK-a11y page Range Input 접근성 v.1.0.0 */
        if(isA11yCheck){
          $input[0].setAttribute('style', `background:-webkit-linear-gradient(to right, ${this.defaults.color} 0%, ${this.defaults.color} ${fill}%, ${this.defaults.bgcolor} ${fill}%, ${this.defaults.bgcolor} 100%);background:linear-gradient(to right, ${this.defaults.color} 0%, ${this.defaults.color} ${fill}%, ${this.defaults.bgcolor} ${fill}%, ${this.defaults.bgcolor} 100%)`);
          this.a11yRangeInit();
        }

        /*! e: FETASK-a11y page Range Input 접근성 v.1.0.0 */
    }
    attachEvents() {
      this.setValue();

      const that = this;
      const $input = this.$el.find('input');
      let preValue = $input.val();
      let fill;
      const $thumb = this.$el.find('.thumb-index'); // 월상환금액

      /*! s: FETASK-a11y page Range Input 접근성 v.1.0.0 */
      const isA11yCheck = isA11yCheckVersion();

      if(isA11yCheck){
        $input.off('input change').on('input change',() => {
          fill = (($input.val() - $input.attr('min')) / ($input.attr('max') - $input.attr('min'))) * 100;
          
          if (that.defaults.type ==  "repayment") {
            $input.css('background', `linear-gradient(to right, ${that.defaults.bgcolorBefore} 12px, ${that.defaults.color} 12px, ${that.defaults.color} ${fill}%, ${that.defaults.bgcolor} ${fill}%, ${that.defaults.bgcolor} 100%)`);
          } else {
            $input.css('background', `linear-gradient(to right, ${that.defaults.color} 0%, ${that.defaults.color} ${fill}%, ${that.defaults.bgcolor} ${fill}%, ${that.defaults.bgcolor} 100%)`);
          }
  
          if (that.defaults.type ==  "repayment") { // 월 상환금액
            const _value = Number((($input.val() - $input.attr('min')) * 100) / ($input.attr('max') - $input.attr('min')))
            if ($input.val() == 1) {
              $thumb.find('.txt').addClass('hide-txt');
              $thumb.find('.first-txt').show();
              $thumb.addClass('pos-left')
            } else {
              that.eventThumb()
              $thumb.find('.txt').removeClass('hide-txt');
              $thumb.find('.first-txt').hide();
              $thumb.removeClass('pos-left')
            }
            //$thumb.attr('idx-num', `${$input.val()}`)
  
            $thumb.css({
              left: `calc(${_value}% + (${-6 - _value * 0.30}px))`
            })
          }
          if (that.defaults.rangeStep == true) {
            const $rangeBalls = that.$el.find('.range-value-group');
            if ($rangeBalls.length > 0) {
              if (preValue > $input.val()) {
                for (var e = $input.val()-1; e <= $input.attr('max'); e++) {
                  $rangeBalls.find('.rvalue').eq(e).removeClass('on').css('background',that.defaults.stepColor)
                }
              } else {
                for (var s = 0; s <= $input.val() - 1; s++) {
                  $rangeBalls.find('.rvalue').eq(s).addClass('on').css('background',that.defaults.color)
                }
              }
            }
          }
          if (that.$el.closest('.living').length > 0) {
            if ($input.val() == 1) {
              $input.addClass('living-first')
            } else {
              $input.removeClass('living-first')
            }
            if ($input.val() == $input.attr('max')) {
              $input.addClass('living-last')
            } else {
              $input.removeClass('living-last')
            }
          }
          if ($input.closest('.living').length>0 &&that.defaults.rangeLen == 4 ) { // 오늘의 예상 주유 금액 4개일때만
            $input.attr('valuenum', `n${$input.val()}`);
          }

          if ($input.closest('[data-saving-range]').length > 0) { // CHPFMTASK-870 한달적금
            $('[data-saving-fraction-current]').text($input.val())
            savingsStory.activeEvent(Number($input.val()))
          }
  
          that.a11yRangeAccess();
          
          preValue = $input.val();
          that.rangeCallBackAction();
        })
      }else{
        // range color setting
        $input.on('input', function() {
          fill = (($input.val() - $input.attr('min')) / ($input.attr('max') - $input.attr('min'))) * 100;
          
          if (that.defaults.type ==  "repayment") {
            $input.css('background', `linear-gradient(to right, ${that.defaults.bgcolorBefore} 12px, ${that.defaults.color} 12px, ${that.defaults.color} ${fill}%, ${that.defaults.bgcolor} ${fill}%, ${that.defaults.bgcolor} 100%)`);
          } else {
            $input.css('background', `linear-gradient(to right, ${that.defaults.color} 0%, ${that.defaults.color} ${fill}%, ${that.defaults.bgcolor} ${fill}%, ${that.defaults.bgcolor} 100%)`);
          }

          if (that.defaults.type ==  "repayment") { // 월 상환금액
            const _value = Number((($input.val() - $input.attr('min')) * 100) / ($input.attr('max') - $input.attr('min')))
            if ($input.val() == 1) {
              $thumb.find('.txt').addClass('hide-txt');
              $thumb.find('.first-txt').show();
              $thumb.addClass('pos-left')
            } else {
              that.eventThumb()
              $thumb.find('.txt').removeClass('hide-txt');
              $thumb.find('.first-txt').hide();
              $thumb.removeClass('pos-left')
            }
            //$thumb.attr('idx-num', `${$input.val()}`)

            $thumb.css({
              left: `calc(${_value}% + (${-6 - _value * 0.30}px))`
            })
          }
          if (that.defaults.rangeStep == true) {
            const $rangeBalls = that.$el.find('.range-value-group');
            if ($rangeBalls.length > 0) {
              if (preValue > $input.val()) {
                for (var e = $input.val()-1; e <= $input.attr('max'); e++) {
                  $rangeBalls.find('.rvalue').eq(e).removeClass('on').css('background',that.defaults.stepColor)
                }
              } else {
                for (var s = 0; s <= $input.val() - 1; s++) {
                  $rangeBalls.find('.rvalue').eq(s).addClass('on').css('background',that.defaults.color)
                }
              }
            }
          }
          if (that.$el.closest('.living').length > 0) {
            if ($input.val() == 1) {
              $input.addClass('living-first')
            } else {
              $input.removeClass('living-first')
            }
            if ($input.val() == $input.attr('max')) {
              $input.addClass('living-last')
            } else {
              $input.removeClass('living-last')
            }
          }
          if ($input.closest('.living').length>0 &&that.defaults.rangeLen == 4 ) { // 오늘의 예상 주유 금액 4개일때만
            $input.attr('valuenum', `n${$input.val()}`);
          }

          if ($input.closest('[data-saving-range]').length > 0) { // CHPFMTASK-870 한달적금
            $('[data-saving-fraction-current]').text($input.val())
            savingsStory.activeEvent(Number($input.val()))
          }
          
          preValue = $input.val();
          that.rangeCallBackAction();
        })
      }
      /*! e: FETASK-a11y page Range Input 접근성 v.1.0.0 */
      
      $input.on('touchend', function() { // 드래그 끝날때 콜백 
        if (that.defaults.type ==  "repayment") { // 월 상환금액
          that.$el.attr('data-value', that.defaults.thumbText[$input.val()-1] )
        }
      })
      this.$el.find('.rvalue').on('click', function(){ // 230728 span 클릭시 input 트리커
        $input.val($(this).attr('num'))
        $input.trigger('input')
      })
    }

    eventThumb() { // 월 상환금액 Thumb 이벤트
      const $input = this.$el.find('input');
      const $thumb = this.$el.find('.thumb-index');
      let num = 0, timer, thumbVal;
      if (this.defaults.thumbText.length > 0) {
        thumbVal = `${this.defaults.thumbText[$input.val()-1]}`
      } else {
        thumbVal = `${$input.val()}년`
      }
      timer = setInterval(() => {
        var value = Math.floor(Math.random() * 10)
        $thumb.find('.txt').text(`${value}년`)
        num++
        if (num > 6) {
          clearInterval(timer)
          $thumb.find('.txt').text(`${thumbVal}년`)
          num = 0;
        }
      }, 50);

    }

    /**
     * 선택된 range의 value index값  *0부터가 아닌 1부터 시작
     * @example 
     * $('.ui-range').data('ui').getValue();
     */
    getValue() {
      const $input = this.$el.find('input');
      let _value;
      if (this.defaults.type == "repayment") { // 월 상환금액
        _value = this.defaults.thumbText[$input.val()-1]
      } else {
        _value = $input.val()
      }

      return _value
    }
    /**
     * 콜백
     * @param callback    {function}  
     * @example 
     * $('.ui-range').data('ui').rangeCallBack();
     */
    rangeCallBack(callback) {
      this.callback = callback;
    }
    rangeCallBackAction() {
        if (this.callback && $.isFunction(this.callback)) {
            this.callback(this);
        }
    }
    detachEvents() {
        this.$el.off(this.eventId);
    }

    destroy() {
        this.detachEvents();
    }

    /*! s: FETASK-a11y page Range Input 접근성 v.1.0.0 */
    a11yRangeAccess(){
      this.a11yInput();
    }
    a11yRangeInit(){
      this.a11yInput();
    }
    a11yInput(){
      const $input = this.$el.find('input')[0];

      const isRangeType = $input.classList.contains('loan-change');
      //let initValue = $input.value - 1;
      let initValue = 0;
      if (this.$el.attr('data-saving-range') != undefined) { // 240906 CHPFMTASK-870
        initValue = $input.value;
      } else {
        initValue = $input.value - 1;
      }
      const { pointerTop, pointerBot, thumbText } = this.defaults;

      let rangeText = '';
      
      if(isRangeType && this.defaults?.type === 'repayment'){
        rangeText = `${thumbText[initValue]}년 약정`;
      }else{
        const arrPointerTop = pointerTop?.length && pointerTop?.split(' '); //range top 배열로 변환
        const arrPointerBot = pointerBot?.length && pointerBot?.split(' '); //range bot 배열로 변환

        if(!arrPointerTop && !arrPointerBot){
          // 신용대출 슬라이더
          //rangeText = `${$input.value - 1}`; 
          if (this.$el.attr('data-saving-range') != undefined) { // 240906  CHPFMTASK-870
            rangeText = `${$input.value}`; 
          } else {
            rangeText = `${$input.value - 1}`; 
          }
        }else{
          // range 기본
          rangeText = `${(arrPointerTop[initValue] || '' + arrPointerBot[initValue]) || ''}`
        }
      }

      $input.setAttribute('value', initValue);
      $input.setAttribute('aria-valuetext', rangeText);
      $input.setAttribute('aria-orientation', 'horizontal');
    }
    /*! e: FETASK-a11y page Range Input 접근성 v.1.0.0 */
}

export default Range;
